import { Component } from '@angular/core';

import { Platform } from '@ionic/angular';
import { SplashScreen } from '@ionic-native/splash-screen/ngx';
import { StatusBar } from '@ionic-native/status-bar/ngx';

import { Router } from '@angular/router';
import { AngularFireAuth } from '@angular/fire/auth';
import { Storage } from '@ionic/storage';


@Component({
  selector: 'app-root',
  templateUrl: 'app.component.html'
})
export class AppComponent {
  public appPages = [
    {
      title: 'Accueil',
      url: '/home',
      icon: 'home'
    },
    {
      title: 'Mon compte',
      url: '/profil',
      icon: 'contact'
    }
  ];
  public darkMode: boolean;
  public colorMode: string;

  constructor(
    private storage: Storage,
    private router: Router,
    public afAuth: AngularFireAuth,
    private platform: Platform,
    private splashScreen: SplashScreen,
    private statusBar: StatusBar
  ) {
    storage.get('darkMode').then((val) => {
      this.darkMode = val;
    });
    this.initializeApp();
  }

  initializeApp() {
    this.platform.ready().then(() => {
      this.afAuth.authState.subscribe(auth => {
        if (!auth) {
          console.log('non connecté');
          this.storage.get('welcome').then((val) => {
            if(val == null) {
              console.log('New user');
              this.storage.set('welcome', true);
              this.router.navigateByUrl('/welcome');
            } else {
              console.log('Old user');
              // this.storage.remove('welcome');
              this.router.navigateByUrl('/login');
            }
          });
        } else {
          this.router.initialNavigation();
          console.log('Connecté: ' + auth.uid);
        }
      });
      this.statusBar.styleDefault();
      this.splashScreen.hide();
    });
  }

  changeDarkMode(event: any) {
    console.log('darkMode: ' + this.darkMode);
    this.storage.set('darkMode', this.darkMode);
    if (!this.darkMode) {
      this.colorMode = 'light';
      // tslint:disable-next-line:max-line-length
      const myCss = 'p{color:black}ion-content{--ion-background-color: white;}ion-icon{color:var(--ion-color-dark)}ion-item{color:black}.bg{background-color: white;}.card {background-color: white;}ion-toolbar {--color: var(--ion-color-dark);--background: var(--ion-color-light);}';
      const myStyle = document.createElement('style');
      // tslint:disable-next-line: deprecation
      myStyle.type = 'text/css';
      myStyle.appendChild(document.createTextNode(myCss));
      const content = document.getElementsByTagName('ion-content')[0].appendChild(myStyle);
    } else {
      this.colorMode = 'dark';
      // tslint:disable-next-line:max-line-length
      const myCss = 'ion-label {color:white}p{color:white}ion-content{--ion-background-color: var(--ion-color-dark);}ion-icon{color:white}ion-item{color:white}.bg{background-color: #1d1d1d;}.card {background-color: var(--ion-color-dark);}ion-toolbar {--color: #ffffff;--background: var(--ion-color-dark);}';
      const myStyle = document.createElement('style');
      // tslint:disable-next-line: deprecation
      myStyle.type = 'text/css';
      myStyle.appendChild(document.createTextNode(myCss));
      const content = document.getElementsByTagName('ion-content')[0].appendChild(myStyle);
    }
  }

}
